<template>
  <div class="row justify-content-center" v-if="loaded">
    <div class="col-lg-6 col-md-8">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div
          class="card-body px-lg-5 py-lg-5 shadow"
          style="border:2px solid #d0d0d0;border-radius:10px;"
        >
          <div class="text-center" v-if="resultCode === 'AUTHORIZED'">
            <img src="@/assets/mail_verify.png" class="img-fluid mb-3" alt="" />
            <h3 class="rscolor">{{ title }}</h3>
            <p class="mb-0">{{ message }}</p>
          </div>

          <div class="text-center" v-else-if="resultCode === 'REJECTED'">
            <img src="@/assets/mail_error.png" class="img-fluid mb-3" alt="" />
            <h3 class="rscolor">{{ title }}</h3>
            <p class="mb-0">{{ message }}</p>
          </div>

          <div class="text-center" v-else>
            <img src="@/assets/mail_error.png" class="img-fluid mb-3" alt="" />
            <h3 class="rscolor">{{ title }}</h3>
            <p class="mb-0">{{ message }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";

const RESULT_TITLES = {
  AUTHORIZED: "Autorización confirmada",
  REJECTED: "Solicitud rechazada",
  EXPIRED: "Enlace expirado",
  NOT_FOUND: "Solicitud no encontrada",
  INVALID: "Solicitud inválida",
  ALREADY_PROCESSED: "Solicitud ya procesada"
};

export default {
  name: "AutorizacionComercioAsociadoRespuesta",
  data() {
    return {
      loaded: false,
      resultCode: "INVALID",
      title: "Autorización comercio asociado",
      message: "No se pudo procesar la solicitud."
    };
  },
  beforeMount() {
    const token = this.$route.query.token;
    const action = this.$route.query.accion;

    if (!token || !action) {
      this.showResult("INVALID", "El enlace de autorización es inválido o está incompleto.");
      return;
    }

    const context = this;
    axiosHelpers.axiosPostWithOutSecurityValidations(
      "AssociatedCommerce/ProcesarRespuestaAutorizacion",
      {
        Token: token,
        Action: action
      },
      context,
      function(data) {
        const result = data.ResponseVM || {};
        const resultCode = result.ResultCode || "INVALID";
        const message =
          result.Message ||
          (data.Alerts && data.Alerts.length > 0 ? data.Alerts[0].Message : null) ||
          "No se pudo procesar la solicitud.";
        context.showResult(resultCode, message);
      }
    );
  },
  methods: {
    showResult(resultCode, message) {
      this.resultCode = resultCode;
      this.title = RESULT_TITLES[resultCode] || "Autorización comercio asociado";
      this.message = message;
      this.loaded = true;
    }
  }
};
</script>

<style scoped>
.rscolor {
  color: #ff4940;
}
</style>
